// Predefined Heraldic Guild Emblems based on categories
import { 
  Music, 
  Truck, 
  BookOpen, 
  Leaf, 
  Heart, 
  Compass, 
  Hammer, 
  Utensils, 
  ShieldCheck, 
  Tag 
} from 'lucide-react';
import { generateHeraldicDataUri, DEFAULT_HERALDIC_CONFIG } from './heraldicSystem';

export * from './heraldicSystem';

const legacyPresets = [
  {
    id: 'entertainment_gastro',
    iconId: 'music',
    name: 'Entertainment & Gastro',
    nameKey: 'categories.ENTERTAINMENT_GASTRO',
    icon: Music,
    color: 'text-rose-400',
    border: 'border-rose-500/60',
    bg: 'bg-rose-950/20'
  },
  {
    id: 'logistics_retail',
    iconId: 'truck',
    name: 'Logistik & Handel',
    nameKey: 'categories.LOGISTICS_RETAIL',
    icon: Truck,
    color: 'text-amber-400',
    border: 'border-amber-500/60',
    bg: 'bg-amber-950/20'
  },
  {
    id: 'tech_education',
    iconId: 'book',
    name: 'Tech & Bildung',
    nameKey: 'categories.TECH_EDUCATION',
    icon: BookOpen,
    color: 'text-indigo-400',
    border: 'border-indigo-500/60',
    bg: 'bg-indigo-950/20'
  },
  {
    id: 'eco_nature',
    iconId: 'leaf',
    name: 'Umwelt & Natur',
    nameKey: 'categories.ECO_NATURE',
    icon: Leaf,
    color: 'text-emerald-400',
    border: 'border-emerald-500/60',
    bg: 'bg-emerald-950/20'
  },
  {
    id: 'health_wellness',
    iconId: 'heart',
    name: 'Gesundheit & Wellness',
    nameKey: 'categories.HEALTH_WELLNESS',
    icon: Heart,
    color: 'text-red-400',
    border: 'border-red-500/60',
    bg: 'bg-red-950/20'
  },
  {
    id: 'mobility_outdoor',
    iconId: 'compass',
    name: 'Mobilität & Outdoor',
    nameKey: 'categories.MOBILITY_OUTDOOR',
    icon: Compass,
    color: 'text-sky-400',
    border: 'border-sky-500/60',
    bg: 'bg-sky-950/20'
  },
  {
    id: 'crafting_repair',
    iconId: 'hammer',
    name: 'Handwerk & Reparatur',
    nameKey: 'categories.CRAFTING_REPAIR',
    icon: Hammer,
    color: 'text-orange-400',
    border: 'border-orange-500/60',
    bg: 'bg-orange-950/20'
  },
  {
    id: 'food_groceries',
    iconId: 'utensils',
    name: 'Lebensmittel & Ernährung',
    nameKey: 'categories.FOOD_GROCERIES',
    icon: Utensils,
    color: 'text-yellow-400',
    border: 'border-yellow-500/60',
    bg: 'bg-yellow-950/20'
  },
  {
    id: 'security_services',
    iconId: 'shield',
    name: 'Soziales & Gemeinschaft',
    nameKey: 'categories.SOCIAL_COMMUNITY',
    icon: ShieldCheck,
    color: 'text-zinc-300',
    border: 'border-zinc-500/60',
    bg: 'bg-zinc-900'
  }
];

export const PREDEFINED_GUILD_EMBLEMS = legacyPresets.map(preset => {
  const url = generateHeraldicDataUri({
    ...DEFAULT_HERALDIC_CONFIG,
    icon: preset.iconId
  });
  return {
    ...preset,
    url,
    label: preset.name
  };
});

export function resolveGuildEmblem(url) {
  if (!url) return url;
  const presetId = url.startsWith('preset:') ? url.slice('preset:'.length) : null;
  const matched = PREDEFINED_GUILD_EMBLEMS.find(preset => preset.id === presetId || preset.url === url);
  return matched?.url || url;
}

export const DEFAULT_GUILD_EMBLEM = PREDEFINED_GUILD_EMBLEMS[8].url;

export function guildEmblemPresetValue(url) {
  const matched = PREDEFINED_GUILD_EMBLEMS.find(preset => preset.url === url || url === `preset:${preset.id}`);
  return matched ? `preset:${matched.id}` : url || `preset:${PREDEFINED_GUILD_EMBLEMS[8].id}`;
}
